import { Component } from '@angular/core';

@Component({
  selector: 'lib-data-form-actions',
  standalone: true,
  template: `
    <div class="data-form-actions">
      <ng-content />
    </div>
  `,
  styles: [`
    .data-form-actions {
      margin-top: 10px;
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
    }
  `],
})
export class DataFormActionsComponent {}
